import { createSingleton } from '../utilities/singleton';
import {
  GeoJson2SvgSetupWorkerInput,
  GeoJson2SvgSetupWorkerOutput,
} from '../workers/geojson2SvgSetup.worker';
import { useWebWorker, WebWorker } from './useWebWorker';

const GeoJson2SvgSetupWorker = WebWorker.bind<
  [() => Worker],
  [],
  WebWorker<GeoJson2SvgSetupWorkerInput, GeoJson2SvgSetupWorkerOutput>
>(
  WebWorker,
  () =>
    new Worker(
      new URL('../workers/geojson2SvgSetup.worker.ts', import.meta.url)
    )
);

const singleton = createSingleton(
  () => new GeoJson2SvgSetupWorker(),
  (worker) => worker.terminate()
);

export const useGeoJson2SvgSetupWorker = (
  setLoading?: (loading: boolean) => void
) => {
  const worker = singleton();
  if (!worker) {
    throw new Error('Failed to get geojson2SvgSetup worker instance');
  }
  return useWebWorker(worker, setLoading);
};
